
export class ShareImagesBase64 {
  public static readonly baner1 = require('@/assets/images/cf_ppl1.png');
}
